"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useState } from "react";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsBoost from "./WaveDropActionsBoost";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropActionsEdit from "./WaveDropActionsEdit";
import WaveDropActionsMore from "./WaveDropActionsMore";
import WaveDropActionsQuickReact from "./WaveDropActionsQuickReact";
import WaveDropActionsRate from "./WaveDropActionsRate";
import WaveDropActionsReply from "./WaveDropActionsReply";
interface WaveDropActionsProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly showVoting?: boolean | undefined;
  readonly onReply: () => void;
  readonly onEdit?: (() => void) | undefined;
  readonly suppressed?: boolean | undefined;
}
export default function WaveDropActions(t0) {
  const $ = _c(20);
  const {
    drop,
    activePartIndex,
    showVoting: t1,
    onReply,
    onEdit,
    suppressed: t2
  } = t0;
  const showVoting = t1 === undefined ? true : t1;
  const suppressed = t2 === undefined ? false : t2;
  const {
    isMemesWave
  } = useSeizeSettings();
  const {
    connectedProfile
  } = useAuth();
  const compact = useCompactMode();
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  const showGuestCopyOnly = !connectedProfile?.handle;
  let t3;
  if ($[0] !== drop || $[1] !== isMemesWave || $[2] !== showVoting) {
    t3 = showVoting && !(drop.drop_type === ApiDropType.Participatory && isMemesWave(drop.wave.id));
    $[0] = drop;
    $[1] = isMemesWave;
    $[2] = showVoting;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const shouldShowVoting = t3;
  let visibilityClasses = "tw-pointer-events-none tw-opacity-0 desktop-hover:group-hover:tw-pointer-events-auto desktop-hover:group-hover:tw-opacity-100 desktop-hover:hover:tw-pointer-events-auto desktop-hover:hover:tw-opacity-100";
  if (isMoreDropdownOpen) {
    visibilityClasses = "tw-pointer-events-auto tw-opacity-100";
  } else {
    if (suppressed) {
      visibilityClasses = "tw-pointer-events-none tw-opacity-0";
    }
  }
  const t4 = `tw-absolute tw-right-2 tw-z-20 ${compact ? "-tw-top-4" : "tw-top-0"} tw-transition-opacity tw-duration-200 tw-ease-in-out ${visibilityClasses}`;
  let t5;
  if ($[4] !== activePartIndex || $[5] !== drop || $[6] !== onEdit || $[7] !== onReply || $[8] !== showGuestCopyOnly) {
    t5 = <div className="tw-flex tw-h-9 tw-items-center tw-gap-x-0.5 tw-rounded-xl tw-bg-iron-950 tw-px-1 tw-shadow-md tw-shadow-black/20 tw-ring-1 tw-ring-inset tw-ring-iron-700/40">{showGuestCopyOnly ? <WaveDropActionsCopyLink drop={drop} /> : <><WaveDropActionsQuickReact drop={drop} /><WaveDropActionsAddReaction drop={drop} /><WaveDropActionsReply onReply={onReply} drop={drop} activePartIndex={activePartIndex} /><WaveDropActionsBoost drop={drop} />{onEdit && drop.drop_type !== ApiDropType.Participatory && <WaveDropActionsEdit drop={drop} onEdit={onEdit} />}<WaveDropActionsMore drop={drop} onOpenChange={setIsMoreDropdownOpen} /></>}</div>;
    $[4] = activePartIndex;
    $[5] = drop;
    $[6] = onEdit;
    $[7] = onReply;
    $[8] = showGuestCopyOnly;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop || $[11] !== shouldShowVoting || $[12] !== showGuestCopyOnly) {
    t6 = !showGuestCopyOnly && shouldShowVoting && <WaveDropActionsRate drop={drop} />;
    $[10] = drop;
    $[11] = shouldShowVoting;
    $[12] = showGuestCopyOnly;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}